import { ClockCircleOutlined, EnvironmentOutlined, IdcardOutlined, UserOutlined } from "@ant-design/icons"
import { Col, Row, Space, Typography } from "antd"
import useLoaderWatchers from "modules/loader-watchers/hooks/useLoaderWatchers"
import PropTypes from "prop-types"
const { Text } = Typography
export const PreviewAddress = ({ trip, t }) => {
  useLoaderWatchers({ watchers: ["trips.trip"] })

  const { address, min_guests, max_guests, licenses_required, available_hours_range } = trip

  return (
    <Row align="bottom" style={{ marginTop: 24, marginBottom: 9, overflowX: "auto" }} gutter={30}>
      {address && (
        <Col>
          <Space align="center">
            <EnvironmentOutlined />
            <Text>{address}</Text>
          </Space>
        </Col>
      )}
      {min_guests && max_guests && (
        <Col>
          <Space align="center">
            <UserOutlined />
            <Text>{min_guests + "–" + max_guests} people</Text>
          </Space>
        </Col>
      )}
      {licenses_required && (
        <Col>
          <Space align="center">
            <IdcardOutlined />
            <Text>{t("trip.labels.licenses_required")}</Text>
          </Space>
        </Col>
      )}
      <Col>
        <Space align="center">
          <ClockCircleOutlined />
          <Text>{available_hours_range ?? "--"}</Text>
        </Space>
      </Col>
    </Row>
  )
}

PreviewAddress.propTypes = {
  trip: PropTypes.shape({
    address: PropTypes.string,
    min_guests: PropTypes.number,
    max_guests: PropTypes.number,
    licenses_required: PropTypes.bool,
    available_hours_range: PropTypes.shape({
      max: PropTypes.shape({
        hours: PropTypes.number
      })
    })
  }).isRequired,
  t: PropTypes.func.isRequired
}
